export default __webpack_public_path__ + "static/media/0x46f48fbdedaa6f5500993bede9539ef85f4bee8e.f34b560c.png";